import styled from 'styled-components'
import { pxToRem } from '../../utils/style'

export const ErrorPageWrapper = styled.div`
	display: flex;
	height: 100vh;
	justify-content: center;
	align-items: center;
`

export const ErrorMessageContainer = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	min-inline-size: ${pxToRem(600)};
	min-block-size: ${pxToRem(300)};
	gap: ${pxToRem(20)};
	background-color: rgba(8, 23, 49, 0.95);
	text-align: center;
	border-radius: ${pxToRem(24)};
`

export const ErrorTitle = styled.h1`
	font-size: ${pxToRem(20)};
	font-weight: 600;
`

export const ErrorDescription = styled.p`
	max-inline-size: ${pxToRem(472)};
	font-size: ${pxToRem(20)};
	font-weight: 400;
	line-height: ${pxToRem(26)};
`
